var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHospitalsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_44)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 6.101V5C20 2.243 17.757 0 15 0H9C6.243 0 4 2.243 4 5V6.101C1.721 6.566 0 8.586 0 11V19C0 21.757 2.243 24 5 24H19C21.757 24 24 21.757 24 19V11C24 8.586 22.279 6.565 20 6.101ZM2 19V11C2 9.696 2.836 8.585 4 8.172V21.828C2.836 21.415 2 20.304 2 19ZM6 5C6 3.346 7.346 2 9 2H15C16.654 2 18 3.346 18 5V22H6V5ZM22 19C22 20.304 21.164 21.415 20 21.828V8.172C21.164 8.585 22 9.696 22 11V19ZM11 14C11 14.552 10.553 15 10 15H9C8.447 15 8 14.552 8 14C8 13.448 8.447 13 9 13H10C10.553 13 11 13.448 11 14ZM16 14C16 14.552 15.553 15 15 15H14C13.447 15 13 14.552 13 14C13 13.448 13.447 13 14 13H15C15.553 13 16 13.448 16 14ZM11 18C11 18.552 10.553 19 10 19H9C8.447 19 8 18.552 8 18C8 17.448 8.447 17 9 17H10C10.553 17 11 17.448 11 18ZM16 18C16 18.552 15.553 19 15 19H14C13.447 19 13 18.552 13 18C13 17.448 13.447 17 14 17H15C15.553 17 16 17.448 16 18ZM13 9C13 9.552 12.553 10 12 10C11.447 10 11 9.552 11 9V8H10C9.447 8 9 7.552 9 7C9 6.448 9.447 6 10 6H11V5C11 4.448 11.447 4 12 4C12.553 4 13 4.448 13 5V6H14C14.553 6 15 6.448 15 7C15 7.552 14.553 8 14 8H13V9Z",
    fill: "#0084D4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_44"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospitalsIcon);
export default __webpack_public_path__ + "static/media/hospitals-icon.af49949247d812167bb46ff0f2f367ff.svg";
export { ForwardRef as ReactComponent };